// Browser-side stub for react-syntax-highlighter — CopilotKit's react-ui
// statically imports `{ Light, Prism }`. The real package drags prismjs,
// refractor, highlight.js (~16 MB on disk) into the bundle just to highlight
// fenced code blocks. A customer-service chat almost never renders code, so
// we ship plain `<pre><code>` instead.

import { createElement } from "react";
import type { ReactNode } from "react";

interface SyntaxHighlighterProps {
  children?: ReactNode;
  [key: string]: unknown;
}

function FallbackCode({ children }: SyntaxHighlighterProps) {
  return createElement(
    "pre",
    { className: "cb-aicsr-codeblock" },
    createElement("code", null, children as ReactNode),
  );
}

export const Light = FallbackCode;
export const Prism = FallbackCode;
export const LightAsync = FallbackCode;
export const PrismAsync = FallbackCode;
export const PrismAsyncLight = FallbackCode;

export default FallbackCode;
